import { UIText1 } from '@cian/ui-kit/typography';
import * as React from 'react';
import clsx from 'clsx';

import * as styles from './Underground.css';
import { UndergroundIcon } from './components/UndergroundIcon';
import { GeoTravelTime } from '../GeoTravelTime';
import { IOfferUnderground } from '../../../../types/geo';

export interface IUndergroundProps {
  regionId: number;
  underground: IOfferUnderground;
  isRedesign?: boolean;
}

export const Underground: React.FC<IUndergroundProps> = ({ regionId, underground, isRedesign }) => {
  // TODO: пока в схеме нет поля `underConstruction`, но будет добавлено
  const { lineColor, name, time, transportType /* , underConstruction */ } = underground;

  return (
    <div className={clsx(styles['container'] /* , underConstruction && styles['under-construction'] */)}>
      {lineColor && <UndergroundIcon className={styles['icon']} color={`#${lineColor}`} regionId={[regionId]} />}
      <span className={styles['name']}>
        <UIText1 display="inline">{name}</UIText1>
      </span>
      {time && transportType && <GeoTravelTime time={time} transportType={transportType} isRedesign={isRedesign} />}
    </div>
  );
};
